import React from 'react'

// CSS
import "../../css/product/create-product.css"

// Services Firebase
import { storage, db } from '../../firebase.js'
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage'
// import { doc} from 'firebase/firestore'
import { collection, doc, setDoc } from 'firebase/firestore'
import { serverTimestamp } from 'firebase/firestore'

// React
import { useState } from "react";
import { useNavigate } from "react-router-dom";
function CreateBlog() {

  const navigate = useNavigate();

  // input values
  const [linkInput, setLinkInput] = useState("")
  const [descriptionInput, setDescriptionInput] = useState("")
  const [pictureUrl, setPictureUrl] = useState("")
  
  // Value Restrictions
  const maxCharacters = 6000

  // errorMessages from BE
  const [errorMessage, setErrorMessage] = useState("");
  const [okMessage, setOkMessage] = useState("")

  // Takes Colection info
  const handleNameChange = (e) => setLinkInput(e.target.value);
  const handleDescriptionChange = (e) => setDescriptionInput(e.target.value)

  // Upload picture to Cloudinary
  // Cloudinary is Loading
  const [isLoadingPicture, setIsLoadingPicture] = useState(false);


  const handlePictureChange = async (e) => {
    setIsLoadingPicture(true)
    const image = e.target.files[0]
    // * upload image to firebaseStorage
    try {

      // 1 - Location where the picture is gonna be saved
      const storageRef = ref(storage, `images/${image.name}`) // 1- storage, 2-image-name-URL || 1 {the ref}, 2 {file it-self}
      // 2 - uploading the picture to firebase storage
      const snapShot = await uploadBytes(storageRef, image)
      // 3 - picture Url
      const downloadUrl = await getDownloadURL(snapShot.ref)
      setPictureUrl(downloadUrl)
      setIsLoadingPicture(false)

      // 4 - new doc
    } catch (error) {
      navigate("/error");
    }

  };

  // Send the input values to BE
  const handleCreateBlog = async (e) => {
    e.preventDefault();

    try {
  const blogRef = collection(db, 'blogs');
  const newBlogRef = doc(blogRef);

  await setDoc(newBlogRef, {
    id: newBlogRef.id,
    link: linkInput,
    picture: pictureUrl,
    description: descriptionInput,
    createdAt: serverTimestamp() // 👈 se guarda fecha de creación
  });

  alert("Blog añadido correctamente");
  window.location.reload(false);
} catch (error) {
  console.log(error);
}
  };

  return (
    <section className="general-container">
      <div className="form-container">
        <form >
          <h3>Crear Blog</h3>

          <div className="input-container">
            <input value={linkInput} onChange={handleNameChange} />
            <label className={linkInput && "filled"} htmlFor="link">
              Link
            </label>
          </div>
          <div className="input-container">
            <textarea
              rows={Math.min(5, Math.max(2, descriptionInput.split('\n').length))}
              value={descriptionInput}
              onChange={handleDescriptionChange}
              maxLength={maxCharacters}
            />
            <label className={descriptionInput && "filled"} htmlFor="name">
              Description
            </label>
            <p>Tienes {maxCharacters - descriptionInput.length} carácteres disponibles</p>
          </div>

          <div className="uploader-pic">
            <input onChange={handlePictureChange} type="file" name="picture" />
            <label htmlFor="picture">Product Picture</label>
          </div>
          {isLoadingPicture === true && <p>...loading picture</p>}
          {/* Show the upload picture in this form */}
          {pictureUrl !== "" ? (
            <img
              src={pictureUrl}
              alt="yourPic"
              width={200}
              className="uploader-img"
            />
          ) : (
            <p> [ No Picture Selected ]</p>
          )}
          <button
            type="submit"
            onClick={handleCreateBlog}
            className="general-btn"
          >
            Crear Blog
          </button>
          {errorMessage !== "" && (
            <p className="error-message"> * {errorMessage}</p>
          )}
          {okMessage !== "" && <p className="ok-message"> * {okMessage}</p>}


        </form>
      </div>


    </section>
  )
}

export default CreateBlog